// @ts-nocheck
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    Session,
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    chain,
    RequestSession,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { createSession } from "@store/Framework/Services/StoreSessionService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

/**
 * Store override of the out-of-the-box `RequestSession` handler that forwards the single-use
 * email-OTP MFA ticket to the store `createSession` (which sends it as the `X-Mfa-Ticket` header).
 * Behavior is otherwise identical to the client-framework handler.
 */
export const StoreRequestSession: HandlerType = async props => {
    if (!props.tokenSuccessfullyRequested) {
        return;
    }

    const { password, rememberMe, keepMeSignedIn, returnUrl, userName } = props.parameter;

    stopWatchingForOtherTabSessionChange(); // Prevent detection of the change we're making here.
    const session = await createSession({
        password,
        rememberMe,
        keepMeSignedIn,
        returnUrl,
        userName,
        accessToken: props.apiResult?.access_token,
        /* Store Custom Code - Start */
        mfaTicket: props.parameter.mfaTicket,
        /* Store Custom Code - End */
    });

    if (!session.successful) {
        watchForOtherTabSessionChange(); // This sign-in failed, but another tab might be successful later on.
        props.parameter.onError?.(session.errorMessage, session.statusCode);
        return;
    }

    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: session.result,
    });

    props.authenticatedSession = session.result;
};

replaceInChain(chain, RequestSession, StoreRequestSession);

const signIn = createHandlerChainRunner(chain, "SignIn");
export default signIn;
